import { container } from '@/container';
import { Logger } from '@/services/Logger';
import { StatusMsgContext } from '@/services/StatusMsgContext';
import { Toaster } from '@/services/toaster/Toaster';
import { translateStatusMsg } from '@/utils/translateStatusMsg';
import { IStatusMsg } from '~/api/messages/IStatusMsg';

export const toastStatusMsg = async (msg: IStatusMsg) => {
  const toaster = await container.getAsync(Toaster);
  const correlationKey = typeof msg?.correlationKey === 'string' ? msg.correlationKey : undefined;

  const code = typeof msg?.code === 'string' ? msg.code : '';
  const isSuccess = /(^|\.)SUCCESS($|\.)/i.test(code);

  // Requirement: only show SUCCESS toasts when correlationKey exist and match
  // an entry that was stored when the request was invoked.
  if (isSuccess) {
    if (!correlationKey) {
      const logger = container.get(Logger);
      logger.captureMessage('Dropped message', {
        tags: {
          store: 'TripStore',
          action: msg?.mType ?? 'StatusMsg',
        },
      });
      return;
    }

    const statusMsgContext = container.get(StatusMsgContext);
    const entry = statusMsgContext.getEntry(correlationKey);
    if (!entry) {
      return;
    }

    // Skip the success toast when the invoke caller opted out.
    // Remove the entry so it is not processed again.
    if (entry.suppressSuccessToast) {
      statusMsgContext.delete(correlationKey);
      return;
    }

    const { message } = translateStatusMsg(msg);

    // Remove request-context after translating so translateStatusMsg can still access it.
    statusMsgContext.delete(correlationKey);

    toaster.success(message);
    return;
  }

  const { message } = translateStatusMsg(msg);
  toaster.error(message);
};
